exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bg-gray[data-v-08dc1ffd]{background-color:#f7f7f7}\n", ""]);

